import { css as _css } from "@emotion/react";
import { useTranslation } from 'react-i18next';
import { theme } from '@arc/frontend/ui-theme';
export function ListPaginationTotal(props) {
  const {
    totalItems,
    itemType,
    sidebarView,
    className
  } = props;
  const {
    t
  } = useTranslation();
  return <p css={/*#__PURE__*/_css({
    marginRight: '1rem',
    fontWeight: '400',
    color: sidebarView ? theme.colors.text.secondary : theme.colors.text.primary,
    marginBottom: 4,
    marginTop: 4,
    whiteSpace: 'nowrap'
  }, process.env.NODE_ENV === "production" ? "" : ";label:ListPaginationTotal;")} className={className}>
			{totalItems === undefined ? t('pagination.loading') : t(`pagination.${itemType || 'item'}`, {
      count: totalItems
    })}
		</p>;
}